import { render, staticRenderFns } from "./divider-widget.vue?vue&type=template&id=675de20f&scoped=true&"
import script from "./divider-widget.vue?vue&type=script&lang=js&"
export * from "./divider-widget.vue?vue&type=script&lang=js&"
import style0 from "./divider-widget.vue?vue&type=style&index=0&id=675de20f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675de20f",
  null
  
)

export default component.exports